/**
 * Labstep
 *
 * @module core/Table/Simple/Header
 * @desc Simple table header component
 */

import type React from 'react';
import { Table } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { ITableSimpleHeaderProps } from './types';

export const TableSimpleHeader: React.FC<ITableSimpleHeaderProps> = ({
  columns,
}) => (
  <Table.Header>
    <Table.Row>
      {columns.map((column, index) => (
        <Table.HeaderCell
          // FIXME react/no-array-index-key
          key={index}
          className={styles.header}
          {...column.cellProps}
        >
          {column.header}
        </Table.HeaderCell>
      ))}
    </Table.Row>
  </Table.Header>
);
